import { digger } from '@cbre/digger';
import { areaUomAbbrev, formatNumber, simpleValueValidation } from '@miq/utils';

function getTotalAvailable(record) {
  const officeUsagesPath = `usages[ref_property_usage_type_desc='Office']`;
  const availableSpace = `total_available_surface_area`;
  const availableSpaceUOM = `total_available_surface_area_uom_desc`;
  const fullPath = `${officeUsagesPath}.${availableSpace}`;
  const availableUOMFullPath = `${officeUsagesPath}.${availableSpaceUOM}`;
  const landlordValue = formatNumber(digger(record.data, fullPath), undefined, '.0-0');
  const uomValue = digger(record.data, availableUOMFullPath);
  const uomValidation = simpleValueValidation(uomValue) ? areaUomAbbrev(uomValue) : '';
  return simpleValueValidation(landlordValue) ? `${landlordValue} ${uomValidation}` : '-';
}

export const emeaTotalAvailableSpaceDisplayFunctions = {
  422: {
    // 422 - Total Available Space (Poland & Finland)
    displayFn: getTotalAvailable,
  },
  432: {
    // 432 - Total Available Space (Italy)
    displayFn: getTotalAvailable,
  },
  509: {
    // 509 - Total Available Space (Norway)
    displayFn: getTotalAvailable,
  },
  519: {
    // 519 - Total Available Space (Norway)
    displayFn: getTotalAvailable,
  },
  499: {
    // 499 - Total Available Space (Sweden)
    displayFn: getTotalAvailable,
  },
};
